export const CONSOLE = 'console';
export const ROLLBAR = 'Rollbar';
